export interface SignUpFormState {
  name: string;
  phoneNumber: string;
  email: string;
  password: string;
  confirmPassword: string;
}

export enum SignUpStage {
  PERSONAL_DETAILS = 0,
  PASSWORD = 1,
  SUBSCRIPTION = 2,
  SUCCESS = 3,
}

export interface StageProps {
  form: SignUpFormState;
  setForm: (form: SignUpFormState) => void;
  setStage: (stage: SignUpStage) => void;
  error?: string | boolean;
  setError: (error: string | boolean) => void;
  loading?: boolean;
  onNext?: () => void;
}
